/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Чекбоксы</h2>
    <p className={styles.description}>
      Работа с чекбоксами проста и понятна. Чекбокс может быть всего в 2-х состояниях:{' '}
      <code className={styles.code}>true</code> или <code className={styles.code}>false</code>.{' '}
    </p>
    <p className={styles.description}>Особенности чекбоксов: </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Имя атрибута которому передается текущее значение из <code className={styles.code}>state</code>. Для чекбоксов
        это <code className={styles.code}>checked</code>, и передаем туда буль
      </li>
      <li className={styles.list__item}>
        При обработке события <code className={styles.code}>onChange</code>, для получения значения, в объекте события
        обращаемся к свойству <code className={styles.code}>event.target.checked</code>
      </li>
      <li className={styles.list__item}>
        Если чекбокс должен хранить значение, его так же можно повесить на атрибут{' '}
        <code className={styles.code}>value</code> и прочитать из объекта события
      </li>
    </ul>
    <p className={styles.description}>
      Добавим к нашей форме регистрации чекбокс для подтвержения пользовательского соглашения, и сделаем кнопку сабмита
      неактивной пока неактивен чекбокс.
    </p>
    <CopyBlock
      text={`const INITIAL_STATE = {
  login: '',
  email: '',
  password: '',
  agreed: false,
};

class SignUpForm extends React.Component {
  state = {
    ...INITIAL_STATE,
  };

  handleChange = ({ target }) => {
    const { name, value, type, checked } = target;

    // Если тип элемента checkbox, берем значение checked,
    // в противном случае value
    this.setState({ [name]: type === 'checkbox' ? checked : value });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { login, email, password, agreed } = this.state;

    console.log(\`
      Login: $ {login}
      Email: $ {email}
      Password: $ {password}
      Agreed: $ {agreed}
    \`);

    /* ... */
  };

  render() {
    const { login, email, password, agreed } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        {/* ... */}
        <label>
          Agree to terms
          <input
            type="checkbox"
            checked={agreed}
            onChange={this.handleChange}
          />
        </label>

        <button type="submit" disabled={!agreed}>
          Sign up as {login}
        </button>
      </form>
    );
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
